<app-header></app-header>
<div class="body-container clearfix">
    <div>
        <div class="row">
            <div class="col-12 box">
                <div class="col-12 box-title">
                    Nice! The documents have been sent to the customer to be signed.
                </div>
            </div>

            <div class="col-12 box-list">
                <h2>
                    Here’s what happens next:
                </h2>
                <ol>
                    <li>
                        The customer will get an email with a link taking them to sign their documents.
                    </li>
                    <li>
                        They will enter their bank info and sign the lease agreement.
                    </li>
                    <li>
                        Once the docs are signed, you will receive your Purchase Order via email and you may release the
                        items or setup delivery. That email will instruct you on how to get paid!
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>